import { render, staticRenderFns } from "./WhatsappBusinessNew.vue?vue&type=template&id=4c1821a3"
import script from "./WhatsappBusinessNew.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports